import styled, { css } from "styled-components";
import { ContributionListWrapper } from "../../../../../../../../CommonComponents/commonStyles";

const styles = css`
  font-family: HelveticaNeue;
  font-size: 12px;
  color: #505050;
`;

const inputstyles = css`
    background: transparent;
    border: none;
    border-bottom: 1px solid #000000;
    width: 100%;
`;

const MediumText = css`
    font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};
`;

const BoldText = css`
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-weight: ${props => props.theme.fontWeight.normal};
`;

export const LetterOfAuthorization = styled.div`
     padding:${props => props.width ? '' : '20px'};
     ${styles}
     font-size: ${props => props.width ? '16px' : '12px'};
     width: ${props => props.width ? '100%' : '70%'};
     @media only screen and (min-width: 320px) and (max-width: 767px) {
        width: 100%; 
        font-size: ${props => props.width ? '14px' : '12px'};
    }

    @media print {
        width: 100%;
    }
`;

export const CorporationInstructions = styled(LetterOfAuthorization)`
    border: 1px solid ${props => props.theme.colors.tabHead};
    margin-bottom: 40px;
    padding: 10px 20px 20px 20px ;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      padding: 10px;
    }
`;

export const FontMediumText = styled.div`
    font-family: HelveticaNeue-Medium !important;
`;

export const FontBoldText = styled.span`
    font-family: HelveticaNeue-Bold !important;
`;
export const Header = styled.div`
    color: #006778;
    margin-top: 10px;
    font-family: BerkeleyStd-Book;
    font-size: 24px;
`;

export const Subheader = styled.div`
    ${BoldText}
`;

export const LetterContent = styled.div`
    margin: 20px 0 20px;
`;

export const InstructionList = styled.ol`
    padding-inline-start: 12px;
    li {
        ${BoldText}
        margin-top: 15px;
        div {
            ${styles}
        }
        table {
            margin:10px 0px;
            width: 85%;
            td,th {
                ${BoldText}
                padding: 2px;
            }
            td {
                 ${ContributionListWrapper}
                height: 20px;
            }
        }
    }
`;

export const InstructionListCheck = styled(InstructionList)`    
    counter-reset: list;
    > li {
        ${BoldText}
        list-style: none;
        > span {
            text-decoration: underline;
        }
        &:before {
            content: "[" counter(list) "] ";
            counter-increment: list;
        }
    }
`;

export const ContentSubList = styled.ul`
    li {
        font-family: ${props => props.theme.fontFamily.helveticaNeue};
        font-size: ${props => props.theme.fontSize.primary};
        color: ${props => props.theme.fontColors.textColor};
        margin-top: 5px;
    }
    @media only screen and (min-width: 320px) and (max-width: 767px) {
        padding-inline-start: 25px;
    }
`;

export const ContributionSubList = styled.ol`
    li {
        ${BoldText}
        margin-top: 5px;
        span{
            ${ContributionListWrapper}
        }
    }
`;

export const InstructionSubList = styled.ol`
    li {
        ${ContributionListWrapper}
        margin-top: 5px;
    }
`;

export const OwnerAuthority = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    div:first-child {
        ${BoldText}
    }
    div {
        margin-top: 0px;
    }
    div:last-child {
        display: flex;
        div {
            width: 50%;
            display: table;
            margin-right: 30px;
            label {
                display: table-cell;
                width: 15%;
                white-space: nowrap;
                vertical-align: bottom;
            }
            input {
                display: table-cell;
                ${inputstyles}
            }
        }
    }
`;

export const VanguardRepresentative = styled.div`
    display: flex;
    margin-top: 20px;
    div:first-child {
        width: 50%;
        border: 1px solid #000000;
        padding: 10px 10px 10px 30px;
        position: relative;
        input[type="checkbox"] {
            position: absolute;
            top: 50%;
            left: 10px;
            transform: translateY(-50%);
        }
    }
    div:last-child {
        margin-left: 50px;
        input {
            ${inputstyles}
        }
    }
`;

export const SignGurantee = styled.div`
    border: 1px solid #000000;
    padding: 0 5px 20px 5px;
    margin-top: 20px;
    div:nth-child(3) {
        margin-top: 10px;
    }
`;

export const FormInput = styled.div`
    display: table;
    width: ${props => (props.Width != undefined) ? props.Width : '100%'};
    label {
        width: 15%;
        display: table-cell;
        white-space: nowrap;
        vertical-align: bottom;
    }
    input {
        display: table-cell;
        ${inputstyles}
    }
`;

export const AuthorizedOffice = styled.div`
    border: 1px solid #000000;
    width: 50%;
    margin-top: 20px;
    height:200px;
    position: relative;
    div:last-child {
        position: absolute;
        bottom: 0;
    }
`;

export const Mail = styled.div`
    margin-top: 10px;
    span {
        ${BoldText}
    }
`;

export const Email = styled(Mail)`
    margin-top: 20px;
    span {
        color: #006778;
        text-decoration: underline;
    }
`;

export const Fax = styled(Mail)`
    margin-top: 20px;
`;

export const Guildelines = styled.div`
    ${styles}
    margin-top: 20px;
    span {
        color: #006778;
        text-decoration: underline;
        font-style: italic;
    }
`;

export const AboutVanguard = styled.div`
    margin-top: 20px;
`;

export const CharityACDetails = styled.div`
    margin-left: ${props => props.marginLeft}
    div {
        input[type="text"] {
            border: 1px solid #000000;
            margin-left: 10px;
        }
    }
`;

export const Print = styled.div`
    position: absolute;
    top: 70px;
    right: 32%;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
        top: 30px;
        right: 10px; 
    }
`;

export const Image = styled.div`
    display: flex;
    justify-content: ${props => props.justifyContent}
    margin-bottom: ${props => props.marginBottom}
`;

export const OfficeAddress = styled.div`
    display: flex;
    div {
        width: 50%;
        div:first-child {
            ${MediumText}
            margin-bottom: 5px;
            margin-top: 0px;
            width: 100%;
        }
        div {
            margin-top: 0;
        }
    }
`;

export const Address = styled.div`
    div:first-child {
        margin-left:0px;
    }
    div {
        margin-left : 20px;
        margin-top: 5px;
        input[type="text"] {
            border: 1px solid #000000;
            margin-left: 10px;
        }
    }  
`;

export const AuthorizationText = styled.span`
    color: ${props => props.color ? props.color : '#d76c41'};
    font-style: italic;
`;

export const LetterWrapper = styled.div`
     margin-top: -170px;

     @media only screen and (min-width: 320px) and (max-width: 767px) {
        margin-top: -250px ;
    }
`;

export const GiftWrapper = styled.div`
    font-family: HelveticaNeue;
    font-size: 16px;
    color: #505050;
    display: flex;
    div:first-child {
        margin-right: 20px;
    }
    @media only screen and (min-width: 320px) and (max-width: 767px) {
        flex-direction: column;
        font-size: ${props => props.theme.fontSize.secondary};
        div:first-child {
            margin-bottom: 5px;
        }
    }
`;

export const ContentWrap = styled.div`
    margin-top:10px;
    margin-left: ${props => props.marginLeft ? props.marginLeft : '0'};
    @media only screen and (min-width: 320px) and (max-width: 767px) {
        margin-top: 5px;
        margin-left: ${props => props.mL ? props.mL : '5px'};
    }
`;

export const ContentBoldUnderline = styled.span`
    text-decoration: underline;
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
`;

export const FundingList = styled.ol`
    counter-reset: item;
    padding: 0px;
        li {
        display: block;
        margin-top:5px;
    }
    li::before {
        display: inline-block;
        content: counter(item) ") ";
        counter-increment: item;
        margin-right: 5px;
    }
`;

export const SuccessMessage = styled.div`
font-size: ${props => props.theme.fontSize.h4};
line-height: ${props => props.theme.lineHeight.primary};
letter-spacing: ${props => props.theme.letterSpacing.normal};
font-family: ${props => props.theme.fontFamily.helveticaNeueLight};
color: ${props => props.theme.fontColors.green};
@media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.h5};
    line-height: ${props => props.theme.lineHeight.normal};
  }
`;